module.exports = __webpack_public_path__ + "static/media/03-banner-06-perisur@2x.b86b86b8.jpg";